define(["exports", "react", "latinize", "react-highlight-words"], function (_exports, _react, _latinize, _reactHighlightWords) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _latinize = _interopRequireDefault(_latinize);
  _reactHighlightWords = _interopRequireDefault(_reactHighlightWords);

  var Highlight = function Highlight(_ref) {
    var textToHighlight = _ref.textToHighlight,
        searchWords = _ref.searchWords;
    return /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
      highlightStyle: {
        background: 'rgba(247, 144, 42, 0.2)',
        color: 'inherit',
        fontWeight: 'inherit'
      },
      searchWords: searchWords,
      autoEscape: true,
      sanitize: _latinize.default,
      textToHighlight: textToHighlight
    });
  };

  Highlight.defaultProps = {
    searchWords: []
  };
  var _default = Highlight;
  _exports.default = _default;
});